// SeuComponente.js

import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import config from '@pkgs/shared-client/config';
import usePersistentSetting, {
	PersistentSettingKeys,
} from '@apps/www/src/www/hooks/usePersistentSetting';

interface SVReCaptchaProps {
	onChange: (value: string | null) => void;
}

const SVReCaptcha: React.FC<SVReCaptchaProps> = ({ onChange }) => {
	const [isDarkMode] = usePersistentSetting(PersistentSettingKeys.DARK_MODE);

	return (
		<ReCAPTCHA
			sitekey={config.reCaptcha.siteKey}
			onChange={onChange}
			theme={isDarkMode ? 'dark' : 'light'}
		/>
	);
};

export default SVReCaptcha;
